const OPEN_PATH = "api/";
const AUTH_PATH = "auth_api/";
const EntityConstants = {
    SIGNIN: `${OPEN_PATH}signin`,
    FORGET_PASSWORD: `${OPEN_PATH}forget_password`,
    CURRENT_USER: `${AUTH_PATH}current_user`,
    PASSWORD_CHANGE: `${AUTH_PATH}password_change`,
    OPEN_COMPANIES: `${OPEN_PATH}companies`,
    MENU_AND_PERMISSION: `${AUTH_PATH}menus_and_permissions`,
    GROUPS: `${AUTH_PATH}groups`,
    LOCATIONS: `${AUTH_PATH}locations`,
    LOCATIONS_BY_ZONE: `${AUTH_PATH}locations_by_zone`,
    DEPARTMENTS: `${AUTH_PATH}departments`,
    ZONES: `${AUTH_PATH}zones`,
    ZONES_BY_SCHOOL: `${AUTH_PATH}zones_by_school`,
    AREAS: `${AUTH_PATH}areas`,
    AREAS_BY_ZONE: `${AUTH_PATH}areas_by_zone`,
    COMPANIES: `${AUTH_PATH}companies`,
    SCHOOLS: `${AUTH_PATH}schools`,
    SCHOOLSBYCOMPANIES: `${AUTH_PATH}schools_by_companies`,
    STUDENTS: `${AUTH_PATH}students`,
    STUDENTS_DOWNLOAD: `${AUTH_PATH}download_students`,
    STUDENT_TRANSPORT_DETAILS: `${AUTH_PATH}student_transport_details`,
    STUDENT_TRANSPORT_DETAIL_BY_STUDENT: `${AUTH_PATH}active_student_transport_detail_by_student`,
    SOA_INVOICES_BY_STUDENT: `${AUTH_PATH}soa_invoices_by_student`,
    INVOICES_BY_STUDENT: `${AUTH_PATH}invoices_by_student`,
    ACADEMIC_YEARS: `${AUTH_PATH}academic_years`,
    ACADEMIC_YEARS_BY_SCHOOL: `${AUTH_PATH}academic_years_by_school`,
    ACADEMIC_YEAR_BY_SCHOOL: `${AUTH_PATH}academic_year_by_school`,
    ACADEMIC_YEAR_BY_TYPE: `${AUTH_PATH}academic_year_by_type`,
    USERS: `${AUTH_PATH}users`,
    TRANSPORT_TYPES: `${AUTH_PATH}transport_types`,
    FEES_TYPES: `${AUTH_PATH}fees_types`,
    FEES_SETUPS: `${AUTH_PATH}fees_setups`,
    TRANSACTION_CODE_SETUPS: `${AUTH_PATH}transaction_code_setups`,
    NOT_IN_TRANSACTION_CODE_SETUP: `${AUTH_PATH}not_in_transaction_code_setup`,
    CLASS_PROMOTIONS: `${AUTH_PATH}class_promotions`,
    PROMOTING: `${AUTH_PATH}promoting`,
    BUS_DETAILS: `${AUTH_PATH}bus_details`,
    FINANCE_TRANSACTION_CODE_SETUPS: `${AUTH_PATH}finance_transaction_code_setups`,
    MODE_OF_PAYES: `${AUTH_PATH}mode_of_payes`,
    CURRENCIES: `${AUTH_PATH}currencies`,
    CUSTOMERS: `${AUTH_PATH}customers`,
    SUPPLIERS: `${AUTH_PATH}suppliers`,
    ACCOUNT_LEDGERS: `${AUTH_PATH}account_ledgers`,
    BANK_DETAILS: `${AUTH_PATH}bank_details`,
    MAIN_GROUP_LEDGERS: `${AUTH_PATH}main_group_ledgers`,
    MAIN_GROUP_LEDGER_ACCOUNTS: `${AUTH_PATH}main_group_ledger_accounts`,
    CHEQUE_TRANSACTION_SETUPS: `${AUTH_PATH}cheque_transaction_setups`,
    CASH_LEDGERS: `${AUTH_PATH}cash_ledgers`,
    GROUP_HEADERS: `${AUTH_PATH}group_headers`,
    MAIN_GROUPS: `${AUTH_PATH}main_groups`,
    SUB_ACCOUNTS: `${AUTH_PATH}sub_accounts`,
    ACCOUNTS: `${AUTH_PATH}accounts`,
    ACCOUNT_TREE: `${AUTH_PATH}account_tree`,
    INVOICE_HEADERS: `${AUTH_PATH}invoice_headers`,
    BULK_DELETE_INVOICES: `${AUTH_PATH}bulk_delete_invoices`,
    INVOICE_LINES: `${AUTH_PATH}invoice_lines`,
    INVOICE_LINES_BY_INVOICE_HEADER: `${AUTH_PATH}invoice_lines_by_invoice_header`,
    STUDENT_INVOICE_TERMS: `${AUTH_PATH}student_invoice_terms`,
    ACTIVE_INVOICE_HEADERS_BY_SCHOOL: `${AUTH_PATH}active_invoices_by_school`,
    PDF_INVOICE_DOWNLOAD: `${AUTH_PATH}invoice_download`,
    RECEIPT_HEADERS: `${AUTH_PATH}receipt_headers`,
    RECEIPT_LINES: `${AUTH_PATH}receipt_lines`,
    RECEIPT_LINES_BY_RECEIPT_HEADER: `${AUTH_PATH}receipt_lines_by_receipt_header`,
    PDF_RECEIPT_DOWNLOAD: `${AUTH_PATH}receipt_download`,
    GRADES: `${AUTH_PATH}grades`,
    TERMS: `${AUTH_PATH}terms`,
    FORMS: `${AUTH_PATH}forms`,
    CSV_STUDENT_DOWNLOAD: `${AUTH_PATH}csv/students`,
    CSV_AREA_DOWNLOAD: `${AUTH_PATH}csv/areas`,
    CSV_STUDENT_UPLOAD: `${AUTH_PATH}csv/students`,
    CSV_AREA_UPLOAD: `${AUTH_PATH}csv/areas`,
    JOURNALS: `${AUTH_PATH}journals`,
    VOUCHERS: `${AUTH_PATH}vouchers`,
    VOUCHER_LINES: `${AUTH_PATH}voucher_lines`,
    VOUCHER_PDF_DOWNLOAD: `${AUTH_PATH}voucher_pdf_download`,
    SPLITUP_LINES_BY_VOUCHER: `${AUTH_PATH}splitup_lines_by_voucher`,
    COMMON_CODES: `${AUTH_PATH}common_codes`,
    GENERATE_INVOICES_BY_STUDENT: `${AUTH_PATH}generate_invoices_by_student`,
    CREDIT_NOTES: `${AUTH_PATH}credit_notes`,
    CREDIT_NOTE_LINES: `${AUTH_PATH}credit_note_lines`,
    CREDIT_NOTE_PDF_DOWNLOAD: `${AUTH_PATH}credit_note_pdf_download`,
    DEBIT_NOTES: `${AUTH_PATH}debit_notes`,
    DEBIT_NOTE_LINES: `${AUTH_PATH}debit_note_lines`,
    DEBIT_NOTE_PDF_DOWNLOAD: `${AUTH_PATH}debit_note_pdf_download`,
    PDF_STUDENT_FEES_INVOICE: `${AUTH_PATH}student_fees_invoice`,
    STUDENT_OUTSTANDING_BALANCE: `${AUTH_PATH}student_outstanding_balance`,
    SOA_ACCOUNTS: `${AUTH_PATH}soa_accounts`,
    SOA_DOWNLOAD: `${AUTH_PATH}soa_download`,
    STUDENT_SOA_DOWNLOAD: `${AUTH_PATH}student_soa_download`,
    GENERATION_INVOICES_BY_SCHOOLS: `${AUTH_PATH}generate_invoices_by_schools`,
    DISCOUNTS: `${AUTH_PATH}discounts`,
    ACTIVE_INVOICES_BY_STUDENT: `${AUTH_PATH}active_invoices_by_student`,
    INVOICES_DOWNLOAD: `${AUTH_PATH}download_invoices`,
    RECEIPTS_DOWNLOAD: `${AUTH_PATH}download_receipts`,
    UNPAID_INVOICE_MONTHS: `${AUTH_PATH}unpaid_invoice_months`,
    DAILY_FEE_COLLECTIONS: `${AUTH_PATH}daily_fee_collections`,
    OUTSTANDING_FEES: `${AUTH_PATH}outstanding_fees`,
    DAILY_FEE_COLLECTIONS_DOWNLOAD: `${AUTH_PATH}download_daily_fee_collections`,
    OUTSTANDING_FEES_DOWNLOAD: `${AUTH_PATH}download_outstanding_fees`,
    MISSING_INVOICES: `${AUTH_PATH}missing_invoices`,
    OTHER_FEES_REPORT: `${AUTH_PATH}other_fees_report`,
    OTHER_FEES_REPORT_DOWNLOAD: `${AUTH_PATH}download_other_fees_report`,
    DASHBOARD_SUMMARY: `${AUTH_PATH}dashboard_summary`,
    FREEZE_INVOICE: `${AUTH_PATH}freeze_invoice`,
    UNFREEZE_INVOICE: `${AUTH_PATH}unfreeze_invoice`,
    BULK_FREEZE_INVOICES: `${AUTH_PATH}bulk_freeze_invoices`,
    BULK_UNFREEZE_INVOICES: `${AUTH_PATH}bulk_unfreeze_invoices`,
    TOGGLE_SCHOOL_STATUS: `${AUTH_PATH}toggle_school_status`,
};
export default EntityConstants;